// Resources.js
import React from 'react';
import {
  FileText,
  BookOpen,
  PenTool,
  FlaskConical,
  GraduationCap,
  Wrench,
} from 'lucide-react';
import './Resources.css';

const coePillars = [
  {
    icon: <FlaskConical />,
    title: 'Research & Development',
    desc: 'A shared space to explore and build — advancing applied research in data, AI, and sustainable technology.',
  },
  {
    icon: <GraduationCap />,
    title: 'Talent Building',
    desc: 'Nurturing the next generation of engineers with skills that industry actually needs.',
  },
  {
    icon: <Wrench />,
    title: 'Real-World Problem Solving',
    desc: 'Helping engineering institutions train their graduates on real problems — not just textbook exercises.',
  },
];

const upcoming = [
  {
    icon: <FileText />,
    title: 'White papers',
    desc: 'Deep dives on data strategy, governance, and ESG reporting practice.',
  },
  {
    icon: <BookOpen />,
    title: 'Case studies',
    desc: 'How organizations put sustainable data practices to work.',
  },
  {
    icon: <PenTool />,
    title: 'Blog',
    desc: 'Shorter notes on what we are learning and building.',
  },
];

const Resources = () => {
  return (
    <div className="resources-page">
      <section className="page-hero">
        <div className="wrap">
          <span className="eyebrow">Resources</span>
          <h1>Learning, research, and sharing.</h1>
          <p className="page-hero-sub">
            Where we invest in knowledge — through our academic partnership,
            and the insights we publish along the way.
          </p>
        </div>
      </section>

      {/* Technology Center of Excellence */}
      <section className="coe-band on-dark">
        <div className="wrap">
          <span className="eyebrow">Center of Excellence</span>
          <h2 className="section-title">
            Technology CoE with JNNCE.
          </h2>
          <p className="coe-lede">
            Our joint Technology Center of Excellence with Jawaharlal Nehru
            New College of Engineering (JNNCE) helps us drive research and
            development, build talent, and support engineering institutions
            in giving their graduates real-world problem-solving experience.
          </p>
          <p className="coe-about">
            Established in 1980 by the National Education Society (NES),
            JNNCE has a rich legacy of quality technical education. The
            institution is affiliated with Visvesvaraya Technological
            University (VTU), Belagavi, approved by AICTE, and recognized by
            the Government of Karnataka.
          </p>
          <div className="coe-grid">
            {coePillars.map((p) => (
              <div key={p.title} className="coe-tile">
                <span className="coe-icon">{p.icon}</span>
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="res-band">
        <div className="wrap">
          <span className="eyebrow">Library</span>
          <h2 className="section-title">The library is being prepared.</h2>
          <div className="card-trio">
            {upcoming.map((u) => (
              <div key={u.title} className="light-card">
                <span className="light-card-icon">{u.icon}</span>
                <h3>{u.title}</h3>
                <p>{u.desc}</p>
              </div>
            ))}
          </div>

          <div className="res-notify">
            <p>Want to know when the first resources are published?</p>
            <a
              className="btn btn-ghost"
              href="mailto:info@sustunetech.com?subject=Notify%20me%20about%20new%20resources"
            >
              Get notified
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Resources;
